import { useState, useEffect } from "react";
import axios from "axios";
import { Link as LinkIcon, Copy, ExternalLink, ChevronRight } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BDMLinksCard = ({ authHeader }) => {
  const [groups, setGroups] = useState([]);
  const [open, setOpen] = useState({});

  useEffect(() => {
    axios
      .get(`${API}/bdm/links`, { headers: authHeader() })
      .then((r) => {
        const g = (r.data?.groups || []).filter((x) => (x.links || []).length > 0);
        setGroups(g);
        setOpen(g.length ? { [g[0].key]: true } : {});
      })
      .catch(() => setGroups([]));
  }, [authHeader]);

  const copy = async (url) => {
    await navigator.clipboard.writeText(url);
    toast.success("Link copied");
  };

  return (
    <div className="bg-white border border-linen-border rounded-3xl shadow-soft p-6" data-testid="bdm-links-card">
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-teal">
        <LinkIcon size={13} /> My links
      </div>
      <h3 className="mt-1 font-heading font-medium text-xl text-navy">Everything you hand out</h3>
      <p className="mt-1 text-sm text-ink-500">
        Your officer's pages, print pieces already branded for them, and the links for bringing in
        other partners.
      </p>

      <div className="mt-4 space-y-2">
        {groups.map((g) => {
          const isOpen = !!open[g.key];
          return (
            <div key={g.key} className="rounded-2xl border border-linen-border overflow-hidden">
              <button
                type="button"
                onClick={() => setOpen((p) => ({ ...p, [g.key]: !isOpen }))}
                data-testid={`bdm-links-group-${g.key}`}
                className="w-full flex items-center justify-between gap-2 px-4 py-3 bg-linen/60 hover:bg-linen text-left"
              >
                <span className="text-sm font-semibold text-navy">{g.label}</span>
                <span className="flex items-center gap-2 text-[11px] text-ink-500">
                  {g.links.length}
                  <ChevronRight className={`w-4 h-4 transition-transform ${isOpen ? "rotate-90" : ""}`} />
                </span>
              </button>
              {isOpen && (
                <ul className="divide-y divide-linen-border">
                  {g.links.map((l) => (
                    <li key={l.url} className="px-4 py-3">
                      <p className="text-sm font-medium text-navy">{l.label}</p>
                      {l.use ? <p className="text-xs text-ink-500 mt-0.5">{l.use}</p> : null}
                      <div className="mt-2 flex items-center gap-3">
                        <a
                          href={l.url}
                          target="_blank"
                          rel="noreferrer"
                          className="inline-flex items-center gap-1 text-[11px] text-teal hover:underline"
                        >
                          Open <ExternalLink className="w-3 h-3" />
                        </a>
                        <button
                          type="button"
                          onClick={() => copy(l.url)}
                          className="inline-flex items-center gap-1 text-[11px] text-ink-500 hover:text-navy"
                        >
                          <Copy className="w-3 h-3" /> Copy
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BDMLinksCard;
